import { toastr } from 'react-redux-toastr';
import get from 'lodash/get';
import castArray from 'lodash/castArray';
import storeJs from 'store';
import { logout } from '../utils/helpers/store';
import Jwt from '../utils/helpers/jwt';

export const baseApiUrl = process.env.API_HOST;
export const kibanaHost = 'http://localhost:5601';

export const parseAuth = (auth) => {
  const token = auth.split(' ')[1];
  storeJs.set('jwt', token);
  const jwt = new Jwt(token).parse();
  return jwt;
};

export const handleError = (e) => {
  if (e.status === 401) {
    if (e.responseJSON.message === 'Failed to Login') {
      logout();
    }
    const message = 'Unable to process the request, authorization required.'
    toastr.error(e?.responseJSON?.message || message);
  } else if (e.status === 403) {
    const message = 'Forbidden. Please login to continue.'
    toastr.error(e?.responseJSON?.message || message)
  } else if (e.status === 404) {
    const message = 'Unable to process the request, record not found.'
    toastr.error(e?.responseJSON?.message || message)
  } else if (e.status === 406) {
    const message = 'Failed to send. Make sure you are resetting the password on the correct platform'
    toastr.error(e?.responseJSON?.message || message)
  } else if (e.status >= 500) {
    toastr.error('Server error');
  } else {
    const error = get(e, 'responseJSON.message', ['Unable to process the request, please try again later.']);
    toastr.error(castArray(error).join(', '));
  }
};

export const handleSuccess = (data, jqXHR) => {
  const { success } = data;
  const toastrOptions = jqXHR.status === 207 ? { timeOut: 0 } : null;
  if (success) {
    toastr.success(success, toastrOptions);
  }
};

export const tokenOptions = (url, params, getState) => {
  const { auth: { data: { token } } } = getState();
  const headers = {};
  if (token) {
    return { headers: { ...headers, Authorization: `Bearer ${token}` } };
  }
  return { headers };
};

export const adapterJquery = (url, options) => {
  const { cb, rcb } = options;
  const { cb: _, ...opts } = options;

  return new Promise((resolve, reject) => {
    $.ajax({ ...opts, data: JSON.stringify(opts.data), contentType: 'application/json', url })
      .done((data, textStatus, jqXHR) => {
        if (cb) return cb(resolve, reject, jqXHR);
        handleSuccess(data, jqXHR);
        return resolve(data);
      })
      .fail((e) => {
        if (rcb) return rcb(resolve, reject, e);
        handleError(e);
        reject(e);
      });
  });
};
